<template>
  <div class="role-auth-document">
    <div  class="role-auth-content"  v-if="!!node">
      <div class="role-auth-title">角色权限</div>
      <div class="role-right-bottom">
        <template>
          <div v-if="node.$isOperation" class="role-rigth-title">请设置<b style="color:#3873fe;">{{ node.roleName }}</b>分类下角色的权限</div>
          <div v-else class="role-rigth-title">请设置<b>{{ node.roleName }}</b>的权限</div>
        </template>
        <template>
          <div class="role-right-table" v-if="node.$isOperation != '1'">
            <rolePermisson :tableData="tableData" :roleType="type"></rolePermisson>
            <el-button type="primary" size="small" class="role-right-button" @click="submit"  :disabled="isDisabled">保存</el-button>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="uncheckNode">
        <img :src="require('@/CommonDP/assets/暂无数据.png')" />
        <span style="color:gray;font-weight:300;font-size:14px;">请选择分类/角色节点</span>
    </div>
  </div>
</template>
<script>
import rolePermisson from "@/views/components/rolePermisson"
import request from "@/CommonDP/service/docPrivi-service";
import { mapState } from "vuex";
export default {
  components:{ rolePermisson },
  data() {
    return {
      filterText: "",
      roleducmentList: [],
      major_png: require('@/CommonDP/assets/settings/major.png'),
      role_png: require('@/CommonDP/assets/settings/systemRole.png'),
      tableData: [],
      initRoleList:[],
    };
  },
  props: {
      type: {
          required: true
      },
      node: {
          require: true
      }
  },
  watch: {
      node: {
          handler(val) {
              if (val) {
                  this.getDocumentList()
              }
          },
          deep: true
      },
      type: {
          handler(val) {
              this.getDocumentList()
          }
      }
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initRoleList) === JSON.stringify(this.tableData)
    },
  },
  methods: {
   
    // 获取对应的权限
    async getDocumentList() {
      let { $isOperation, roleID } = this.node
      if ($isOperation === '1') {
        const params = { enterpriseId: this.enterpriseId, folderCode: roleID, folderArea: parseInt(this.type) }
        const res = await request.getListForCheckedSpec(params);
        this.tableData = res.data.map((item) => {
          if (item.isRead === 2) {
            item.$show = 1;item.$down = 1;
          } else if (item.isRead === 1) {
            item.$show = 1;item.$down = 0;
          } else {
            item.$show = 0;item.$down = 0;
          }
          if (item.isRead === 2 && item.fileNew === 1 && item.folderNew === 1 && item.fileDel === 1 && item.isSubmit === 1 && item.isPlaceFile === 1 && item.isPrint === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="1") {
            item.$selectAll = 1;
          }else if(item.$show === 1 && item.$down === 1  && item.folderNew === 1 && item.fileDel === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="2"){
             item.$selectAll = 1;
          }else if (item.$show === 1 && item.$down === 1 && item.fileNew === 1 && item.folderNew === 1 && item.fileDel === 1 && item.isPrint === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="3") {
           item.$selectAll = 1;
         }  else {
            item.$selectAll = 0;
          }
          return item
        })
        this.initRoleList = JSON.parse(JSON.stringify(this.tableData))
      } else {
        const params = { enterpriseId: this.enterpriseId, operObject: roleID, folderArea: parseInt(this.type) }
        const res = await request.getListForCheckedRole(params);
        this.tableData = res.data.map((item) => {
          item.name = item.roleName;
          if (item.isRead === 2) {
            item.$show = 1;item.$down = 1;
          } else if (item.isRead === 1) {
            item.$show = 1;item.$down = 0;
          } else {
            item.$show = 0;item.$down = 0;
          }
         if (item.isRead === 2 && item.fileNew === 1 && item.folderNew === 1 && item.fileDel === 1 && item.isSubmit === 1 && item.isPlaceFile === 1 && item.isPrint === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="1") {
            item.$selectAll = 1;
          }else if(item.$show === 1 && item.$down === 1  && item.folderNew === 1 && item.fileDel === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="2"){
             item.$selectAll = 1;
          }else if (item.$show === 1 && item.$down === 1 && item.fileNew === 1 && item.folderNew === 1 && item.fileDel === 1 && item.isPrint === 1 && item.isPriviSet === 1 && item.priviAll === 1 && item.isSnapshot === 1&&this.type==="3") {
           item.$selectAll = 1;
         } else {
            item.$selectAll = 0;
          }
          return item
        })
        this.initRoleList = JSON.parse(JSON.stringify(this.tableData))
      }
    },
    
    async submit() {
      const { tableData } = this;
      const array = tableData.map((item) => {
        if (item.$show === 1 && item.$down === 1) item.isRead = 2;
        else if (item.$show === 1 && item.$down === 0) item.isRead = 1;
        else item.isRead = 0;
        return item;
      })
      const res = await request.updateListForCheckedRole(array);
      if (res.result === '0') this.$message.success("提交成功")
      await this.getTreeList();
    },
  }
};
</script>
<style lang="scss">
.role-auth-aside{
  .el-tree-node__content {
    line-height: 20px;
    padding: 4px;
  }
}
.role-right-table{
  .el-checkbox{
    margin-right: 20px;
    .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #2E384D !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.uncheckNode {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
    > img {
        margin: 10px 0px;
    }
}
.role-auth-document{
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  .role-auth-content {
    position: absolute;
    left: 0px;
    right: 0;
    bottom: 0;
    top: 0;
    .role-auth-title{
      padding: 17px;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
    }
    .role-right-bottom{
      padding:0 17px;
      .role-rigth-title{
        color:#58667A;
        font-size: 14px;
        line-height: 18px;
      }
      .role-right-table{
        overflow: auto;
        position: absolute;
        top: 83px;
        bottom: 10px;
        right: 0;
        padding-right: 20px;
        left: 17px;

      }
      .role-right-button{
        float: right;
        margin-top: 10px;
      }
    }
  }
  .empty{
    text-align: center;
    font-size: 36px;
    color: #ddd;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .textAll{
    width:150px;
    font-size: 16px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
}
</style>
